<template>
  <v-app v-if="preloading">
    <v-container  fluid fill-height style="background-color: #3b3b3b;">
      <v-row>
        <v-col class="d-flex justify-center">
          <v-img src="/img/logo.png" contain max-width="240"/>
        </v-col>
      </v-row>
      <v-row align-center justify-center>
        <v-col cols="4" offset="4" style="display:flex; justify-content: center">
          <v-progress-circular
              indeterminate
              :size="70"
              :width="9"
              color="accent"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col class="d-flex justify-center">
          {{loaded}} / {{modules.length}}
        </v-col>
      </v-row>
    </v-container>
  </v-app>
  <v-app v-else>
    <div class="wrapper">
      <optionsNav v-model="drawerOption"></optionsNav>
      <v-app-bar color="primary" dark fixed app clipped-left>
        <v-app-bar-nav-icon @click.stop="drawerMain = !drawerMain">
          <v-icon>mdi-menu</v-icon>
        </v-app-bar-nav-icon>
        <AccountSwitcher />
        <v-spacer/>
        <v-btn text :href="`${REACT_URL}/calendar`">CALENDAR</v-btn>
        <global-search />
        <v-btn v-if="accountCan(account, AccountFeatures.XPERIENCE) && $can('access', 'Order')" text :href="`${REACT_URL}/simulator`">Xperience</v-btn>
        <bell-menu v-if="$can('access', 'Options')"/>
      </v-app-bar>
      <main-nav v-model="drawerMain"></main-nav>
      <v-main>
        <v-container fluid fill-height>
          <v-layout>
            <v-flex>
              <zoom-center-transition :duration="200" mode="out-in">
                <router-view></router-view>
              </zoom-center-transition>
              <v-snackbar v-model="snackDisplay" :timeout="2000" :color="snackColor" top>
                {{ snackText }}
              </v-snackbar>
              <FlashMessage></FlashMessage>
            </v-flex>
          </v-layout>
        </v-container>
      </v-main>
    </div>
  </v-app>
</template>

<script>
import mainNav from "./mainNav.vue";
import optionsNav from "./optionsNav.vue";
import { ZoomCenterTransition } from "vue2-transitions";
import GlobalSearch from "@components/globalSearch/GlobalSearch"
import {mapActions, mapGetters} from 'vuex';
import BellMenu from '../../components/notifications/BellMenu.vue';
import { REACT_URL } from "../../common/config-local";
import AccountSwitcher from "@components/AccountSwitcher.vue";
import {AccountFeatures} from "@/utils/enum";
import {accountCan} from "@/utils/account.utils";
export default {
  components: {
    AccountSwitcher,
    mainNav,
    optionsNav,
    ZoomCenterTransition,
    GlobalSearch,
    BellMenu
  },
  data: () => ({
    drawerMain: false,
    drawerOption: false,
    right: false,
    left: false,
    snackDisplay: false,
    REACT_URL
  }),
  computed: {
    AccountFeatures() {
      return AccountFeatures
    },
    ...mapGetters("auth", ["currentUser"]),
    ...mapGetters('currencies', {currenciesLoaded: 'loaded'}),
    ...mapGetters('shops', {shopsLoaded: 'loaded'}),
    ...mapGetters('catalogs', {catalogsLoaded: 'loaded'}),
    ...mapGetters('account', {account: 'account', accountLoaded: 'loaded'}),
    snackText: function() {
      return this.$store.getters["app/snackText"];
    },
    snackColor: function() {
      return this.$store.getters["app/snackColor"];
    },
    modules () {
      return [
        this.shopsLoaded,
        this.currenciesLoaded,
        this.catalogsLoaded,
        this.accountLoaded
      ]
    },
    loaded() {
      return this.modules.filter(m => m).length
    },
    progress () {
      return this.loaded / this.modules.length * 100
    },
    preloading () {
      return this.loaded !== this.modules.length
    }
  },
  watch: {
    snackText(newVal) {
      if (newVal) this.snackDisplay = true;
    },
    snackDisplay(newVal) {
      if (newVal == false) {
        this.closeSnack();
      }
    }
  },
  mounted: function() {
    this.check_auth()
    this.getCurrencies();
    this.getShops();
    this.getCatalogs()
    this.getAccount()
  },
  props: {
    source: String
  },
  methods: {
    accountCan,
    ...mapActions("currencies", {getCurrencies : "list"}),
    ...mapActions("shops", {getShops:"list"}),
    ...mapActions("catalogs", ["getCatalogs"]),
    ...mapActions("account", {getAccount: "get"}),
    ...mapActions("auth", ['check_auth']),
    closeSnack() {
      this.$store.dispatch("app/closeSnackBar");
    }
  }
};
</script>
